import { render, staticRenderFns } from "./VeeJsonEdit.vue?vue&type=template&id=ed8f7bba&"
import script from "./VeeJsonEdit.vue?vue&type=script&lang=js&"
export * from "./VeeJsonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports